import { render, staticRenderFns } from "./InfoScreen.vue?vue&type=template&id=37dd6e3e&scoped=true"
import script from "./InfoScreen.vue?vue&type=script&lang=js"
export * from "./InfoScreen.vue?vue&type=script&lang=js"
import style0 from "./InfoScreen.vue?vue&type=style&index=0&id=37dd6e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd6e3e",
  null
  
)

export default component.exports